<template>
  <div id="policy-mate" class="listStyle">
    <template v-if="!isMatch">
      <div class="bg-box">
        <van-image  :src="homeImg" />
      </div>
      <div class="content-box">
        <van-field class="company-cell" 
          v-model="companyVal"
          required
          placeholder="请填写公司名称"
          :error-message="errMsg.companyVal"
          label="公司名称" />
        <van-field v-model="valuePC"  required readonly label="所属地域"
          placeholder="请选择所在地域"
        right-icon="arrow-down"
        @click="openAreaPop()"/>
        <van-field v-model="industryVal"  required readonly label="所属行业" 
          type="textarea" rows="1" autosize
          placeholder="请选择所属行业"
          right-icon="arrow-down"
          :error-message="errMsg.industryVal"
          @click="openIndustryPop()"/>
        <van-field v-model="projectVal"  required readonly label="所属项目" 
          placeholder="请选择所属项目"
          right-icon="arrow-down"
          :error-message="errMsg.projectVal"
          @click="openProjectPop()" />
        <!-- <van-field v-if="phone" v-model="phone" required label="联系电话"
          :disabled="true"/> -->
        <van-field  v-model="tel" label="联系电话"
          placeholder="请输入联系电话"
          :error-message="errMsg.tel" />
        <div class="mate-box" @click="goMatch()">
          <van-button block round>立即匹配</van-button>
        </div>
      </div>
      <!-- 地区 -->
      <van-popup
        v-model="showAreaPop"
        position="bottom"
        :style="{ height: '80%' }">
        <div class="selectNavS">
          <van-area
            title="城市切换"
            :area-list="areaList"
            :columns-num="3"
            :visible-item-count="13"
            @confirm="clickConfirmArea"
            @cancel="showAreaPop = false"
          />
        </div>
      </van-popup>
      <van-popup 
        v-model="showIndustryPop"  closeable position="bottom">
        <h3 class="industry-pop-title">选择所属行业</h3>
        <van-tree-select
          :items="industryList"
          :active-id.sync="activeIdsP"
          :main-active-index.sync="activeIndexP"
          selected-icon="checked"
          class="industry-nav"
          height="400px" 
          @click-item="onItemClick"
        />
        <div class="mate-box" @click="showIndustryPop=false">
          <van-button block round>确定</van-button>
        </div>
      </van-popup>
      <!-- 项目 -->
      <van-popup
        v-model="showProjectPop" round position="bottom" :style="{height:'80%'}">
        <div style="text-align:center">
          <van-cell
            v-for="it in projectList"
            :title="it.title"
            :key="it.value"
            @click="pickPeoject(it.value, it.title)"
          ></van-cell>
        </div>
      </van-popup>
    </template>
    <template v-else>
      <div class="bg-res-box">
        <div class="location-wapper">
          <van-image width="13px" height="15px" :src="locationPng"/>
          <span style="margin:0 5px" v-if="valueP">{{valueP}}</span>
          <span style="margin:0 5px" v-else>北京</span>
          <span v-if="valueC">{{valueC}}</span>
        </div>
        <div class="title-wapper">
          <p>优惠政策</p>
        </div>
        <div class="classify-wapper" >
          <span class="industry-tab tabAll" 
            :class="chosedTab == 1 || chosedTab == 3? 'chosed-tab': ''" 
            @click="chooseTab(1)">优惠行业
            <span class="sanjiao"></span>
          </span>
          <span class="project-tab tabAll"
            :class="chosedTab == 2? 'chosed-tab': ''" 
            @click="chooseTab(2)">优惠项目</span>
        </div>
        <div class="file-box">
          <div class="file-item" 
            v-for="(it, i) in currentResList" :key="i"
            @click="enterDetail(it)">
            <div class="file-wapper">
              <p v-html="it.fname"></p>
              <span class="wsx-btn" v-if="it.potence=='尚未生效'">
                {{it.potence}}</span>
              <span class="yx-btn" v-if="it.potence=='全文有效'">
                {{it.potence}}</span>
              <span class="fz-btn" v-if="it.potence=='部分废止'">
                {{it.potence}}</span>
            </div>
            <div class="file-num information-line" v-if="it.fcode"> 
              <van-image width="22px" :src="wenhao"/>
              <span>{{it.fcode}} </span>
            </div>
            <div class="tax-category information-line" v-if="it.tax">
              <van-image width="22px"  :src="shuiZ"/>
              <span>{{it.tax}}</span>
            </div>
            <div class="info-wapper">
              <div class="info-item">
                <van-image width="12" height="12" class="shrink-0" :src="hgPng"/>
                <span class="van-ellipsis">{{it.publisher}}</span>
              </div>
              <div class="info-item shrink-0">
                <van-image width="12" height="12" class="shrink-0" :src="datePng"/>
                <span>{{parseTime(it.pbdate)}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="new-match-wapper">
          <!-- 分页 -->
          <div class="pageBoxStyle">
            <Pagination
              :currentPage="currentPage"
              :total="total"
              :totalLists="totalLists"
              :isHaveNumber="isHaveNumber"
              @prevPage="prevPage"
              @nextPage="nextPage"
              @jumpToPageSize="jumpToPageSize"
              @refreshProtect="refreshProtect"
              @relogin="tmpLogin"
            ></Pagination>
          </div>
          <van-button class="new-match-btn" block @click="newMatch()">
            重新匹配
          </van-button>
        </div>
      </div>
      <van-popup
        v-model="showIndusPop"
        position="bottom"
        round
        :style="{ height: '35%' }">
        <div class="category-wapper">
          <span class="cancel" @click="showIndusPop = false">取消</span>
          <p>项目类别</p>
          <span class="sure" @click="chooseTab(3)">确定</span>
        </div>
        <div class="category-box">
          <!-- <span
            :class="classify == 1 ? 'chosed-category' : ''"
             @click="changefy('1')">{{industryVal? industryVal: ''}}</span> -->
          <span 
            v-for="list in industyyPickedList" :key="list.id"
            :class="classify == 1 && industryCode == list.id ? 
              'chosed-category' : ''"
            @click="changefy('1', list.id)">
            {{list.text}}
          </span>
          <span
            :class="classify == 2 ? 'chosed-category' : ''"
            @click="changefy('2')">通用规定</span>
        </div>
      </van-popup>
    </template>
  
    <!-- 列表组件 -->
    <list-content
      ref="listContent"
      @refreshProtect="refreshProtect"
    ></list-content>
  </div>
</template>

<script>
import { wxRedirectUrl } from "../../../public/config.json";
import { wxConfig } from "@/utils/newLibs/getWxOptions.js";
import { getTempLocation } from "@/utils/lib/tempLogin.js"; // 临时登录
import { matchUrl } from "../../../public/config.json";
import { parseTime } from '@/utils/time.js';
import ListContent from "@/components/common/listContent";
import { commonDialog } from "@/utils/lib/toast.js";
import { searchToObj, getUrlParam, getShareParam} from "@/utils/lib/searchtoobj.js";
import Pagination from "@/components/common/pagination"; // 分页
export default {
   data () {
    return {
      areaList: [],
      companyVal:'',
      industryList: [],
      activeIdsP: [],
      activeIndexP: 0,
      industryVal: "",
      industyyPickedList: [],
      industryCode: "",
      projectList:[],
      projectCode: "",
      projectVal: "",
      showAreaPop: false,
      showIndustryPop: false,
      showProjectPop: false,
      tel:'',
      errMsg: {
        tel: '',
        projectVal: '',
        industryVal: '',
        companyVal: ''
      },
      currentPcode: "",
      currentCcode: "",
      pattern: /^1[3456789]\d{9}$/, // 手机号码验证
      homeImg: require("../../assets/policy/bg.png"),
      backImg: require("../../assets/policy/bg2.png"),
      locationPng: require("../../assets/policy/dizhi.png"),
      isMatch: false,
      chosedTab: 1,
      hgPng:require("../../assets/policy/qiye.png"),
      datePng:require("../../assets/policy/riqi.png"),
      shuiZ:require("../../assets/policy/shuiz.png"),
      wenhao:require("../../assets/policy/wenhao.png"),
      showIndusPop: false,
      industryResList: [],
      projectResList: [],
      tyResList: [],
      currentResList: [],
      classify: 1,
      isHaveNumber: false,
      currentPage: 1,
      total: 0,
      totalLists: 0, // 总的条数
      lists: [],
      tytotal: 0,
      tytotalLists: [],
      prototal: 0,
      prototalLists: [],
      hytotal: 0,
      hytotalLists: [],
      args: {},
      valuePC: ''
    }
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    phone() {
      return this.$store.state.user.mobileNum;
    },
    valueP() {
      return this.$store.state.commonSearchData.valueP;
    },
    valueC() {
      return this.$store.state.commonSearchData.valueC;
    },
    valueProvCode() {
      return this.$store.state.commonSearchData.valueProvCode;
    },
    valueCityCode() {
      return this.$store.state.commonSearchData.valueCityCode;
    }
  },
  components: {
    ListContent,
    Pagination,
  },
  watch: {
    $route: {
      handler: function (val) {
        if (val && val.query.relogin == 1) {
          this.tmpLogin(true)
          this.$router.replace(this.$route.path)
        }
        if (val && val.query.relogin == 2) {
          this.refreshProtect()
          this.$router.replace(this.$route.path)
        }
      },
      deep: true
    }
  },
  created () {
    if(!this.$store.state.user.userId) {
      this.tmpLogin()
    } else {
      this.getTree()
      this.getProvinceAndCity()
    }
    if(this.valueP) {
      this.valuePC = `${this.valueP}/${this.valueC}`
    } else {
      this.valuePC = `北京`
    }
  },
  methods: {
    // 进入详情页
    enterDetail(e) {
      console.log(e)
      //this.$refs.listContent.showDetailPopup= true
      this.$refs.listContent.getDetail(e)
    },
    onItemClick(data) {
      const index = this.industyyPickedList.indexOf(data)
      

      if (index != -1) {
        this.industyyPickedList.splice(index, 1)
      } else{
        this.industyyPickedList.push(data)
      }
      this.industryVal = this.industyyPickedList.map((item) => item.text).join('，')
      this.industryCode = this.activeIdsP[0]
    },
    getTree() {
      this.$http.reqGetTree().then((resp) => {
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            this.industryList = resp.datas[1].children[1].children[1].children
            //console.log('kkk2', this.industryList)

            let pro = [{ text: "", children: [], selected: true }];
            this.industryList.forEach((item) => {
              if (!pro[0].children.includes(item.value)) {
                pro[0].children.push({ text: item.title, id: item.value, selected: true });
              }
              if (item.selected && !this.activeIdsP.includes(item.value)) {
                this.activeIdsP.push(item.value);
              }
            });
            this.industryList = pro;
            console.log('kkk3', this.industryList)
            
            this.projectList = resp.datas[1].children[0].children
          }
        }
      })
    },
    pickPeoject(e, val) {
      this.showProjectPop = false
      this.projectVal = val;
      this.projectCode = e;
    },
    clickConfirmArea(e) {
      this.showAreaPop = false
      if(e[2] != undefined) {
       this.$store.commit("commonSearchData/changeValueP", e[1].name);
       this.$store.commit("commonSearchData/changeValueC", e[2].name);
        this.valuePC = `${e[1].name}/${e[2].name}`
        this.currentPcode = e[1].code
        this.currentCcode = e[2].code
      } else {
        this.$store.commit("commonSearchData/changeValueP", e[0].name);
        this.$store.commit("commonSearchData/changeValueC", e[1].name);
        this.valuePC = `${e[0].name}/${e[1].name}`
        this.currentPcode = e[0].code
        this.currentCcode = e[1].code
      }
      //console.log('kkk', this.currentPcode, this.currentCcode)
    },
    closeA() {
      this.$router.push("/newFiles");
    },
    // 临时登录
    tmpLogin (relogin = false) {
      this.$http.reqTempLogin().then((resp) => {
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            this.bus.$emit("saveTokenHandle", resp, 1)
            this.getTree()
            this.getProvinceAndCity()
            if (!relogin) {
              this.wxAuto()
            } else {
              // 如果是已经登录之后isHaveNumber就为false了
              if(!this.isHaveNumber) {
                this.isHaveNumber = true
              } else {
                this.isHaveNumber = false
              }
            }
          }
        }
      })
    },
    

    wxAuto() {
      if(getUrlParam(location.search, 'code')) {
        this.wxLogin()
      } else {
        let req = {
        http_redirct: matchUrl,
        }
        this.$http
          .reqPostGetWeixinPromise(req)
          .then((res) => {
            if (res.rtncode === 1 && res.rltcode === 1) {
              window.location.href = res.item.url
            }
          })
          .catch((err) => {
            commonDialog(err.message, this);
          });
      }
    },
    // 微信登录
    wxLogin () {
      let obj = searchToObj(location.href)
      let tempuserguid = localStorage.getItem("userguid");
      let newObj = {
        code: obj.code,
        state: obj.state,
        tempuserguid: tempuserguid
      };
      this.$http
        .reqPostWeixinLogin(newObj)
        .then((resp) => {
          if (resp.rtncode === 1) {
            if (resp.rltcode === 1) {
              new Promise((resolve, reject) => {
                this.getLocation(resolve);
                }).then(() => {
                  this.bus.$emit("saveTokenHandle", resp, 1)
                })
            } else if (resp.rltcode === -3) {
               this.isHaveNumber = true //未登录
               console.log('没有注册账号')
               new Promise((resolve, reject) => {
                this.getLocation(resolve);
                }).then(() => {
                  this.matchTmpLog()
                })
            } else {
              commonDialog(resp.rltdesc, this);
            }
          } else {
            commonDialog(resp.rtndesc, this);
          }
        })
        .catch((err) => {
          commonDialog(err.message, this);
        });
    },
    matchTmpLog() {
      this.$http.reqMatchUser().then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            //console.log('matchTmp...', res)
            this.bus.$emit("saveTokenHandle", res, 1)
          }
        }
      });
    },
    openAreaPop() {
      this.showAreaPop = true
    },
    openIndustryPop() {
      this.showIndustryPop = true
    },
    openProjectPop() {
      this.showProjectPop = true
    },
     // 点击上一页
    prevPage() {
      if (this.currentPage == 1) return;
      this.currentPage--;
      if(this.chosedTab == 2) {
        this.getProList(this.args)
      } else {
        if(this.classify == 1) {
          this.goMatch()
        } else {
          this.getTyList()
        }
      }
    },
    // 点击下一页
    nextPage() {
      if (this.currentPage == this.total) return;
      this.currentPage++;
      if(this.chosedTab == 2) {
        this.getProList(this.args)
      } else {
        if(this.classify == 1) {
          this.goMatch()
        } else {
          this.getTyList()
        }
      }
    },
    // 跳转到某页
    jumpToPageSize(num) {
      this.currentPage = num;
      if(this.chosedTab == 2) {
        this.getProList(this.args)
      } else {
        if(this.classify == 1) {
          this.goMatch()
        } else {
          this.getTyList()
        }
      }
    },
    // 进入此页后用户登录无微信关联账号，刷新文件保护状态
    refreshProtect() {
      this.isHaveNumber = false
      if(this.chosedTab == 2) {
        this.getProList(this.args)
      } else {
        if(this.classify == 1) {
          this.goMatch()
        } else {
          this.getTyList()
        }
      }
    },
    // 时间戳转化
    parseTime(time) {
      return parseTime(time, '{y}-{m}-{d}')
    },
    // 重新匹配
    newMatch() {
      this.companyVal = ''
      this.industryVal = ''
      // 行业多选项置为空
      this.industyyPickedList = []
      this.activeIdsP = []

      this.projectVal = ''
      this.tel = ''
      this.isMatch = false
    },
    goMatch(){
      if (!this.companyVal) {
        this.errMsg.companyVal = '请填写公司名称'
        return false
      } else {
        this.errMsg.companyVal = ''
      }
      if (!this.industryVal) {
        this.errMsg.industryVal = '请选择行业'
        return false
      } else {
        this.errMsg.industryVal = ''
      }
      if (!this.projectVal) {
        this.errMsg.projectVal = '请选择项目'
        return false
      } else {
        this.errMsg.projectVal = ''
      }
      if (this.tel && !this.pattern.test(this.tel)) {
        this.errMsg.tel = '手机号格式错误'
        return false
      } else {
        this.errMsg.tel = ''
      }
      
       let args = {
        searchtimes: 1, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: "",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: "510100",
            c: "000000",
          },
          dirid: "",
          id: "000002000004000001",
          stime: "",
          etime: "",
          court: "",
          courttype: 1
        },
        second: [],
        fliter: {
          isfilter: true,
          tagpc: [
            { p: "000000", c: "000000" },
            {
              p: this.currentPcode ? this.currentPcode : this.valueProvCode,
              c: "000000",
            },
            {
              p: this.currentPcode? this.currentPcode : this.valueProvCode,
              c: this.currentCcode? this.currentCcode : this.valueCityCode,
            },
          ],
          tagid: "",
        },
        pager: [
          { pagesize: 10, pageindex: this.currentPage }
        ],
        extend: {
          company: this.companyVal,
          mobile: this.tel
        },
        scencs: "policy"
      };
      // 通用列表
      //this.getTyList(args)
      
      this.args = args
      args.frist.id = this.industryCode;
       this.$http.reqMatching(args).then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            console.log('hangye...', res)
            this.isMatch = true
            this.industryResList =
                res.tbls[0].items !== null ? res.tbls[0].items : [];
            this.currentResList = this.industryResList
            this.hytotal = Math.ceil(res.tbls[0].total / 10);
            this.hytotalLists = res.tbls[0].total; // 总的条数
            this.total = this.hytotal
            this.totalLists = this.hytotalLists

            this.$store.commit("search/setIsProtect",res.tbls[0].protect);
            this.$store.commit("search/setWarningLevel",res.tbls[0].warninglevel);
            this.$store.commit("search/setWarningText",res.tbls[0].warningtext);
          }
        }
      })
      // args.frist.id = this.projectCode;
      // this.getProList(args)
    },
    // 获取通用列表
    getTyList() {
      this.args.frist.id = "000002000004000001";
      this.args.pager[0].pageindex = this.currentPage
      this.$http.reqMatching(this.args).then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            console.log('tongyong...', res)
            this.isMatch = true
            this.tyResList =
                res.tbls[0].items !== null ? res.tbls[0].items : [];
            this.tytotal = Math.ceil(res.tbls[0].total / 10);
            this.tytotalLists = res.tbls[0].total; // 总的条数
            this.currentResList = this.tyResList
            this.total = this.tytotal
            this.totalLists = this.tytotalLists

            this.$store.commit("search/setIsProtect",res.tbls[0].protect);
            this.$store.commit("search/setWarningLevel",res.tbls[0].warninglevel);
            this.$store.commit("search/setWarningText",res.tbls[0].warningtext);
          }
        }
      })
    },
    // 获取项目列表
    getProList() {
      this.args.frist.id = this.projectCode
      this.args.pager[0].pageindex = this.currentPage
      this.$http.reqMatching(this.args).then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            console.log('xiangmu...', res)
            this.isMatch = true
            this.projectResList =
                res.tbls[0].items !== null ? res.tbls[0].items : [];
            this.prototal = Math.ceil(res.tbls[0].total / 10);
            this.prototalLists = res.tbls[0].total; // 总的条数
            this.currentResList = this.projectResList
            this.total = this.prototal
            this.totalLists = this.prototalLists

            this.$store.commit("search/setIsProtect",res.tbls[0].protect);
            this.$store.commit("search/setWarningLevel",res.tbls[0].warninglevel);
            this.$store.commit("search/setWarningText",res.tbls[0].warningtext);
          }
        }
      })
    },
    chooseTab(e) {
      this.chosedTab = e
      this.currentPage = 1
      this.showIndusPop = false
      if(this.chosedTab == 1) {
        this.showIndusPop = true
        if(this.classify == 1) {
          this.goMatch()
        } else {
          this.getTyList()
        }
      } else if(this.chosedTab == 2) {
        this.getProList()
      } else {
        this.showIndusPop=false
        if(this.classify == 1) {
          this.goMatch()
        } else {
          this.getTyList()
        }
      }
    },
    changefy(e, m) {
      console.log('xixixi', m)
      this.classify = e
      this.industryCode = m
    },
    // 调用微信的SDK
    getLocation(resolve) {
        // 微信浏览器
      let reqBody = {
        url: matchUrl,
      };
      this.$http
        .reqGetWxConfig(reqBody)
        .then((res) => {
          new Promise((ok, err) => {
            wxConfig(res, ok, err);
          })
            .catch((err) => console.log(err))
            .finally(() => {
              let x = localStorage.getItem("latitude")
                  ? localStorage.getItem("latitude")
                  : 0,
                y = localStorage.getItem("longitude")
                  ? localStorage.getItem("longitude")
                  : 0;
              getTempLocation(resolve, x, y);
              this.showLoading = false;
            });
        })
        .catch((err) => {
          this.showLoading = false;
        })
        .finally(() => {
          resolve();
        });
    },
    // 获取省市的数据
    getProvinceAndCity() {
      this.$http
        .reqGetProvinceAndCity()
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              let provinceAndCitylists = {
                province_list: {},
                city_list: {
                  110100: "北京",
                  120100: "天津",
                  310100: "上海",
                  500100: "重庆",
                },
                county_list: {},
              };
              res.datas.map((item) => {
                provinceAndCitylists.province_list[item.id] = item.label;
                if (item.id === "110000") {
                  if (item.children && item.children.length > 0) {
                    item.children.forEach((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (item.id === "120000") {
                  if (item.children && item.children.length > 0) {
                    item.children.map((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (item.id === "310000") {
                  if (item.children && item.children.length > 0) {
                    item.children.map((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (item.id === "500000") {
                  if (item.children && item.children.length > 0) {
                    item.children.map((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (
                  item.id !== "110000" &&
                  item.id !== "120000" &&
                  item.id !== "310000" &&
                  item.id !== "500000" &&
                  item.children &&
                  item.children.length > 0
                ) {
                  item.children.map((item) => {
                    provinceAndCitylists.city_list[item.id] = item.label;
                  });
                }
              });
              this.areaList = provinceAndCitylists;
              this.$store.dispatch(
                "commonSearchData/updateProvinceAndCity",
                this.areaList
              );
            }
          }
        })
        .catch((err) => {
          console.log("获取城市数据失败", err)
        });
    }
  }
}
</script>

<style lang="less">
sr {
  color: #c00000;
}
</style>

<style lang="less" scoped>
#policy-mate{
  font-size: 14px;
  width: 100%;
  /deep/.van-sidebar {
    display: none;
  }
  .industry-pop-title {
    text-align: center;
  }
  .van-popup__close-icon {
    color: #000;
  }
  .industry-nav {
    height: 410px;
    .van-tree-select__item::after {
      content: '';
      border: 1px solid #c8c9cc;
      border-radius: 50%;
      width: 14px;
      height: 14px;
      display: inline-block;
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
    }

    .van-tree-select__item--active {
      color: #ff6034;
      &::after {
        border-color:transparent ;
      }
      .van-icon-checked {
        font-size: 18px;
      }
    }
  }
  .bg-box {
    /deep/.van-image {
      width: 100%;
    }
    // /deep/.van-field__control {
    //   font-size: 14px;
    // }
  }
  /deep/.van-field__control:disabled {
    -webkit-text-fill-color: #3a3838dd;
  }
  .content-box {
    border-radius: 10px;
    background: white;
    box-shadow: 0 0 5px  rgba(0, 0, 0, 0.1);
    margin: -60px 20px 0 20px;
    padding: 10px 0 20px 0;
    .company-cell {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    /deep/.van-cell {
      padding: 15px 16px;
      font-size: 15px;
    }
    /deep/.van-cell__title {
      color: #000;
    }
  }
  .mate-box {
    margin: 20px 10px 0px 10px;
    /deep/.van-button {
      background-color: #FF6002;
      color: white;
      height: 40px;
    }
  }
  .bg-res-box {
    background-image: url(../../assets/policy/bg2.png);
    background-size: 100% auto;
    height: 180px;
    background-repeat: no-repeat;
    position: relative;
    .location-wapper {
      position: absolute;
      left: 10px;
      top: 20px;
      color: white;
      display: flex;
      align-items: center;
    }
    .title-wapper {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      color: white;
      padding: 20px 0 10px 0;
    }
    .classify-wapper {
      padding: 10px 10px;
      .industry-tab {
        margin-right: 10px;
        padding:8px 15px 8px 10px;
        border-radius: 20px;
        background-color: #FCF2EC;
        position: relative;
        .sanjiao {
          position: absolute;
          top: 13px;
          right:5px;
          border: 6px solid transparent;
          border-top: 6px solid#000;
          border-radius: 4px;
        }
      }
      .project-tab {
        border-radius: 20px;
        padding:8px 10px;
        background-color: #FCF2EC;
      }
      
      .chosed-tab {
        border: 1px solid #E84409;
        color: #E74000;
        .sanjiao {
          border-top: 6px solid#E74000;
        }
      }
    }
    .file-box {
      height: calc(100vh - 200px);
      overflow-y: auto;
    }
    .file-item {
      background-color: #FFFFFF;
      border-radius: 10px;
      padding: 20px;
      margin: 10px;
      .file-wapper {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 10px;
        p {
          color: #000;
          font-weight: bold;
          margin-right: 10px;
           overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .wsx-btn {
          color: #ED7C2C;
          border: 1px solid #ED7C2C;
          flex-shrink: 0;
          padding: 3px 5px;
          border-radius: 3px;
        }
        .yx-btn {
          color: #28BD97;
          border: 1px solid #28BD97;
          flex-shrink: 0;
          padding: 3px 5px;
          border-radius: 3px;
        }
        .fz-btn {
          color: #FF7053;
          border: 1px solid #FF7053;
          flex-shrink: 0;
          padding: 3px 5px;
          border-radius: 3px;
        }
      }
      .file-num {
        color:#666666;
        margin-bottom: 5px;
        font-size: 12px;
        
      }
      .tax-category {
        color: #666666;
        margin-bottom: 5px;
        font-size: 12px;
      }
      .information-line {
        display: flex;
        align-items: center;
        /deep/.van-image {
          flex-shrink: 0;
        }
        span {
          margin-left: 5px;
        }
      }
      .info-wapper {
        display: flex;
        justify-content: space-between;
        background-color: #F4F7FB;
        padding: 10px 10px;

        .info-item {
          color: #80726A;
          display: flex;
          align-items: center;
          overflow: hidden;
          font-size: 12px;

          span {
            margin-left: 5px;
          }
        }

        .shrink-0 {
          flex-shrink: 0;
        }
      }
    }
    .new-match-wapper {
      position: fixed;
      bottom: 0;
      width: 100%;
      //height: 60px;
      background-color: white;
      display: flex;
      justify-content: space-between;
      /deep/.van-button {
        width: 90px;
        background-color: #FF6002;
        color: white;
        height: 40px;
      }
    }
  }
  .category-wapper {
    color: #000000;
    font-size: 16px;
    margin: 10px 0;
    padding: 10px 10px;
    display: flex;
    justify-content: space-between;
    p {
      font-weight: bold;
      font-size: 18px;
    }
    .sure {
      color: #4D8FFE;
    }
  }
  .category-box {
    padding: 0 10px;
    margin: 15px 0 0 0;
    word-break: break-all;
    .chosed-category {
      background-color: #FF6002;
      color: white;
    }
    span{
      background-color: #F5F5F5;
      border-radius: 5px;
      margin-right: 10px;
      padding: 6px 8px;
      margin-bottom: 8px;
      display: inline-block;
    }
  }
  .pageBoxStyle {
    position: fixed;
    bottom: 0px;
    left: 0;
    font-size: 0.37333rem;
    background-color: #fff;
    .totalList {
      flex: 0 0 22%;
      border-top: 1px solid #ebedf0;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #EDEEF0;
    }
    .next {
      flex: 0 0 28% !important;
    }
  }
  .new-match-btn {
    position: fixed;
    bottom: 0px;
    right: 0;
  }
}
</style>